import React from "react";
import { DashType } from "@/features/dashboard";
import { formatLargeValue } from "@/utils/number";
import { Table } from "antd";
import { round } from "lodash";

type Props = {
  data: DashType.StockPerformance[];
};

export default ({ data }: Props) => {
  const columns = [
    {
      title: "Ticker",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Name",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "Market Cap",
      dataIndex: "marketCapBasic",
      key: "marketCapBasic",
      render: (v: number) => formatLargeValue(v)
    },
    {
      title: "Chg %",
      dataIndex: "change",
      key: "change",
      render: (v: number) => formatCell(v)
    },
    {
      title: "Weekly %",
      dataIndex: "perfW",
      key: "perfW",
      render: (v: number) => formatCell(v)
    },
    {
      title: "Monthly %",
      dataIndex: "perf1M",
      key: "perf1M",
      render: (v: number) => formatCell(v)
    },
    {
      title: "3 Month %",
      dataIndex: "perf3M",
      key: "perf3M",
      render: (v: number) => formatCell(v)
    },
    {
      title: "YTD %",
      dataIndex: "perfYtd",
      key: "perfYtd",
      render: (v: number) => formatCell(v)
    }
  ];

  return <Table dataSource={data.sort((a,b) => b.marketCapBasic - a.marketCapBasic)} columns={columns} />;

  function formatCell(value: number) {
    return {
      props: {
        style: { color: value < 0 ? "red" : "green" }
      },
      children: <div>{round(value, 2).toString()}</div>
    };
  }
};
